import { validateUrl, isTokenExpired } from "./utils";
import { createPopToken } from "../popToken/createPop";
import axios from 'axios';

export const axiosPublic = async ({
    method = 'get',
    url,
    data=null,
    otherHeaders = null,
  }) => {
    if (!url || typeof url !== 'string') {
      throw new Error('Invalid URL: URL must be a non-empty string');
    }
  
    // Validate the URL to prevent SSRF attacks
    const isValidUrl = validateUrl(url);
    if (!isValidUrl) {
      throw new Error('Invalid URL: SSRF protection - URL not allowed');
    }
  
    let idToken = sessionStorage.getItem('idToken');
    const isTokenExp = await isTokenExpired(idToken);
  
    // Verify if the token is expired and refresh if necessary
    // if (!idToken || isTokenExp) {
    //   console.log('Token expired or missing, refreshing...');
    //   idToken = await refreshGuestToken();
    // }
  
    const pop_token = createPopToken(method, url, `Bearer ${idToken}`, data);
  
    const headers = {
      ...otherHeaders,
      "Authorization": `Bearer ${idToken}`,
      'X-Auth-Originator': idToken,
      'X-Authorization': pop_token
    };
  
    return axios({
      method,
      url,
      data,
      headers,
    });
  };

